import { Box, useTheme } from "@material-ui/core";
import { equals } from "ramda";
import { FC, memo } from "react";
import { useRecordContext } from "react-admin";

import defaultImg from "../assets/default.svg";

const ListImage: FC<ListImageProps> = (props) => {
  const { source } = props;
  const record = useRecordContext(props);
  const theme = useTheme();

  const src = source.includes(".") ? record[source.split(".")[0]][source.split(".")[1]] : record[source];

  return (
    <Box
      sx={{
        width: 75,
        height: 75,
        borderRadius: "50%",
        overflow: "hidden",
        border: `1px solid ${theme.palette.grey[300]}`,
      }}
    >
      <img
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
        src={src || defaultImg}
        alt={record && record.name && record.name.en}
        loading="lazy"
      />
    </Box>
  );
};

interface ListImageProps {
  source: string;

  [key: string]: any;
}

const areEqual = (prevProps: any, nextProps: any) => {
  return equals(prevProps, nextProps);
};

export default memo(ListImage, areEqual);
